import {DesignBlockData} from "../types/base-design-block.types";

export const defaultDesignBlockData: DesignBlockData = {
  id: 0,
  title: '',
  comment: '',
  history: []
}
